export default "__VITE_ASSET__4vWalMh8__"